import React, { useEffect } from 'react';
import { Grid } from '@material-ui/core';
import { useDispatch, useSelector } from 'react-redux';
import Box from '@material-ui/core/Box';
import { Elements } from '@stripe/react-stripe-js';
import { loadStripe } from '@stripe/stripe-js/pure';
import { HelpDocLink, Link, LoadingFrame } from '../../../components';
import useStyles from './styles';
import { selectCurrentUser } from '../../../store/modules/users/selectors';
import CheckoutForm from './CheckoutForm/CheckoutForm';
import lightHouseArticles from '../../../configs/lightHouseArticles';
import { selectPaymentMethod } from '../../../store/modules/billing/selectors';
import { getPaymentMethodRequest } from '../../../store/modules/billing/actions';
import { selectProductList } from '../../../store/modules/products/selectors';
import { getProductListRequest } from '../../../store/modules/products/actions';

type Props = {
  location?: History;
};

const CheckoutPage = ({ location }: Props) => {
  const classes = useStyles();
  const { data: user } = useSelector(selectCurrentUser);
  const selectedProductCode = location?.state?.productCode;
  const stripeKey = process.env.REACT_APP_STRIPE_API_KEY || '';
  const stripePromise = loadStripe(stripeKey);
  const dispatch = useDispatch();
  const { loading: paymentMethodLoading } = useSelector(selectPaymentMethod);
  const { data: fullProductList } = useSelector(selectProductList);

  useEffect(() => {
    if (!fullProductList) {
      dispatch(getProductListRequest());
    }
  }, [dispatch, fullProductList]);

  useEffect(() => {
    if (user) {
      dispatch(getPaymentMethodRequest(user.id));
    }
  }, [dispatch, user]);

  // useEffect(() => {
  //   if (user?.id && ![2, 91, 47].includes(user?.id)) {
  //     history.push('/dashboard/home');
  //   }
  // }, [user]);


  if (paymentMethodLoading || !user || !fullProductList) {
    return (
      <LoadingFrame />
    );
  }

  return (
    <div className={classes.page}>
      <Grid container justify="center">
        <Grid item className={classes.formWrapper}>
          <Box className={classes.form}>
            <div className={classes.title}>Checkout</div>
            <div className={`${classes.tip} ${classes.topTip}`}>
              Not sure about this plan?
              {' '}
              <Link to="/dashboard/plans/pricing">View plans</Link>
            </div>
            <Elements stripe={stripePromise}>
              <CheckoutForm productCode={selectedProductCode} />
            </Elements>
            <div className={`${classes.tip} ${classes.bottomTip}`}>
              Questions?
              {' '}
              <HelpDocLink id={lightHouseArticles.checkout}>
                Find help
              </HelpDocLink>
            </div>
          </Box>
        </Grid>
      </Grid>
    </div>
  );
};

export default CheckoutPage;
